export default __webpack_public_path__ + "static/media/img14.b5863d32.jpg";